export function jobPageUrlBuilder({ lang, token }) {
  const langString = lang ? `${lang}/` : '';
  return `/positions/${langString}${token}`;
}

export function jobApplyPageUrlBuilder({ lang, token = '' }) {
  const jobUrl = jobPageUrlBuilder({ lang, token });
  return `${jobUrl}/apply/`;
}
